import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Dialog, Classes } from "@blueprintjs/core";
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import UsersTable, { userListLayout } from 'components/Tables/Users';
import * as DataList from 'components/DataList';
import styled from '@emotion/styled';
import InviteUserDialog from 'components/User/inviteUser';
import Sticky from 'react-stickynode';
import SearchBars from 'components/SearchBars';
import UserSidebar from './user-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;  
  min-height: calc(100vh - 75px);
`

@inject('store', 'dashboard', 'viewStore', 'userStore') @observer
class UsersIndexPage extends Component {

  @observable isOpenInviteUserDialog = false;
  @observable isOpenResponseDialog = false;

  showInviteUserDialog() {
    this.isOpenInviteUserDialog = true
  }

  closeInviteUserDialog() {
    this.isOpenInviteUserDialog = false
  }

  onSuccessInviteUser() {
    this.isOpenInviteUserDialog = false
    this.isOpenResponseDialog = true
  }

  handleClose() {
    this.isOpenResponseDialog = false
  }

  render() {
    const {
      props: {
        userStore: {
          inviteUserResponse
        },
        viewStore,
        dashboard,
        dashboard: {
          users: {
            isLoading,
            isError
          }
        }
      }
    } = this;
    const { userSearch } = viewStore;
    const noun = userSearch.section === 'invitations' ? 'invitations' : 'users';
    return (
      <div className="user-page-layout">
        <Helmet>
          <title>{userSearch.section === 'invitations' ? 'Invitations' : 'Users'} | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
            <UserSidebar />
          </div>
          <div className="col-lg-10">

            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.Users key={`${viewStore.currentPath}-${viewStore.listFiltersVersion}`} />
              </Sticky>
              {isLoading && (
                <DataList.Loading
                  {...userListLayout(userSearch.section)}
                  noun={noun}
                />
              )}
              {!isLoading && isError && (
                <DataList.LoadError
                  noun={noun}
                  onRetry={() => dashboard.loadUsers({ section: userSearch.section, where: userSearch.where })}
                />
              )}
              {!isLoading && !isError && <UsersTable />}
            </PageWrapGray>
          </div>
        </div>
        <InviteUserDialog
          isOpen={this.isOpenInviteUserDialog}
          onClose={this.closeInviteUserDialog.bind(this)}
          onSuccess={this.onSuccessInviteUser.bind(this)}
        />
        <Dialog
          title="Invite User"
          icon="info-sign"
          isOpen={this.isOpenResponseDialog}
          onClose={this.handleClose.bind(this)}
        >
          <div className={Classes.DIALOG_BODY}>
            {
              inviteUserResponse.success.length > 0 && 
              <div>
                <h5>Successfull invitation sent:</h5>
                { inviteUserResponse.success.map((user) => {
                  return(
                    <div key={Math.random()}>
                      {user.first_name && <span>{user.first_name} {user.last_name}:</span>} {user.email}
                    </div>
                  )
                })}
              </div>
            }
            
            {
              inviteUserResponse.failed.length > 0 && 
              <div>
                <h5>Failed to sent invitations to the following users:</h5>
                { 
                  inviteUserResponse.failed.map((user) => {
                    return(
                      <div key={Math.random()}>
                        {user.first_name && <span>{user.first_name} {user.last_name}:</span>} {user.email}
                        <br/>
                        {user.errors}
                        <br/> <br/>
                      </div>
                    )
                  })
                }
              </div>
            }
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button onClick={this.handleClose.bind(this)}>CLOSE</Button>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
};

export default UsersIndexPage;